import { PanelbarStructure } from "../isPanelbarDetails";
import { Helper } from "../../util/helper";
import React from "react";
export default class SlaServiceHoursDetails extends React.Component<any, any> {
    render() {
        let data = $.extend({ data: { }}, this.props.data);

        const calendarName: string = Helper.hasValue(data.Calendar) ? data.Calendar.Name : null;

        return (
            <PanelbarStructure label={"Edit schema (for Level only)"} keyPropValue={data.Id} iconName={"folder-open"} url={"SlaServiceHours/Edit?id=" + encodeURIComponent(data.Id)}>
                <table className="templateHoverTable">
                    <tbody>
                        <tr>
                            <td>
                                <span>{data.Title}</span>
                            </td>                            
                        </tr>
                        {!Helper.isNullOrEmpty(calendarName) ? <tr><td><span>{calendarName}</span></td></tr> : null}
                    </tbody>
                </table>
            </PanelbarStructure>);
    }
}
